export default [
  {
    path: '/database-insights/:databaseConfigId',
    name: 'DatabaseInsights',
    component: () => import("@/views/Page/DatabaseInsights/DatabaseInsights.vue"),
    meta: {
      title: '#Default# | Database Insights',
    },
  }
];
